import React from 'react';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import ComponentSlider from 'src/mtska-frontend-app-component/components/Slider/ComponentSlider';
import { Button } from 'src/mtska-frontend-app-component';
import { useSyncDashboardFullscreenClass } from 'src/mtska-frontend-app-scaffolding';
import useFiltersFromLocation from 'src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation';
import { getRentalRunningReportTitle, resolveRentalRunningReport } from './reportResolver';
import { useDashboardReportConfiguration } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/useDashboardReportConfiguration';

const FILTERS_STORAGE_KEY = 'dashboard/rentalFleet';

const RentalRunningConfiguredContainer = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    useSyncDashboardFullscreenClass();
    const [filters, setFilters] = useFiltersFromLocation();
    const { reportConfiguration } = useDashboardReportConfiguration();
    const report = resolveRentalRunningReport({
        t,
        filters: filters ?? { items: [] },
        onClearFilters: () => setFilters({ items: [] }),
        keyPrefix: 'rental',
        filtersStorageKey: FILTERS_STORAGE_KEY,
        reportConfiguration,
    });
    const reportTitle = getRentalRunningReportTitle(reportConfiguration);

    return (
        <Box ref={ref} className="mtska-dashboard-container" sx={{ position: 'relative' }}>
            <Box className="dashboard-section-title" sx={{ marginTop: '10px', marginBottom: '10px' }}>
                <h2>{t(reportTitle)}</h2>
            </Box>

            <ComponentSlider report={report} />

            <Box className="mtska-fullscreen-toggle">
                <Button
                    variant="soft"
                    size="sm"
                    icon="faExpand"
                    onClick={() => {
                        const parent = document.querySelector('.mtska-dashboard-container');
                        if (!parent) return;
                        if (document.fullscreenElement || document.webkitFullscreenElement) {
                            parent.classList.remove('mtska-fullscreen');
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            }
                        } else if (parent.requestFullscreen) {
                            parent
                                .requestFullscreen()
                                .then(() => parent.classList.add('mtska-fullscreen'))
                                .catch(() => parent.classList.remove('mtska-fullscreen'));
                        } else if (parent.webkitRequestFullscreen) {
                            parent.webkitRequestFullscreen();
                            parent.classList.add('mtska-fullscreen');
                        }
                    }}
                    aria-label={t('Fullscreen')}
                />
            </Box>
        </Box>
    );
});

export default RentalRunningConfiguredContainer;
